import firestoreServices from 'src/lib/firestore.service';

const usersFirestoreServices = firestoreServices('users');

export default {
  ...usersFirestoreServices
};
